// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
}

.attendance-outer {
  border: 0.5px solid rgb(162 162 162 / 17%);
  /* border: red; */
  border-radius: 13px;
  width: auto;
}

.header-section {
  width: 98%;
  margin: 10px;
  height: 50px;
  display: flex;
}
.slect_Attendance_month {
  margin-right: 10px;
}
#input-data {
  width: 10%;
  margin-left: 10px;
  padding: 10px;
}

.calender-section {
  margin: 10px;
  width: 78%;
  border: 1px solid rgb(145, 145, 145);
  border-radius: 5px;
}

.calender-data-section {
  display: flex;
  margin-top: -12px;
  justify-content: space-evenly;
}
/* .btn-section {
    display: flex;
    border: 2px solid black;
    width: 20px;
  } */

.select-section {
  margin-left: auto;
  border: 1px solid rgb(165, 164, 164);
  padding: 10px;

  border-radius: 5px;
}

.month-display {
  height: 50px;
  width: 220px;
  display: flex;
  /* justify-content: center; */
  cursor: pointer;
}
#Search {
  background-color: rgb(132, 199, 174);
  color: white;
  padding: 10px;
  width: 70px;
  margin-left: 10px;
  border-radius: 5px;
}

.export {
  background-color: rgb(132, 199, 174);
  color: white;
  margin-left: 10px;
  padding: 10px;
  width: 70px;
  border-radius: 5px;
}

.sub-section {
  width: 100%;
  margin: 0px;
  height: 44px;

  display: flex;
}

.data-section {
  margin: 10px;
  border: 1px solid rgb(153, 153, 153);
  border-radius: 13px;
  min-width: 270px;
  max-width: 100%;
}
@media screen and (max-width: 1024px) {
  .data-section {
    width: 20%;
  }
}

.detail {
  color: cadetblue;
  display: flex;
  justify-content: center;
  align-items: center;
  /* min-width: 200px;
  max-width: 220px; */
}

.detail h3 {
  padding: 10px;
  width: auto;
  margin: 10px;
  text-align: center;
  border-bottom: 2px solid green;
}
.data-section__container {
  margin: 10px;
  width: 250px;
  border: 1px solid rgb(145, 145, 145);
  border-radius: 13px;
}
.data-section__container ul {
  list-style: none;
  margin: auto;
  margin-left: 5px;
}

.data-section__container li {
  margin: 15px;
  margin-left: 12px;
  color: rgb(58, 58, 58);
  opacity: 70%;
  font-size: 13px;
}

.data-section__container span {
  float: right;
  color: rgb(66, 66, 66);
  font-size: 12px;
  font-weight: 550;
}
.data-contenet {
  background-color: white !important;
  padding: 10px;
}

.calender-weekday {
  font-weight: 600;
}

.calender-weekday,
.cal-day {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-top: 10px;
  text-align: center;
  color: rgb(84 141 119);
}

.calenderDay {
  display: flex;
  flex-direction: column;
  padding: 1px;
  font-size: 0.9rem;
  color: #6b8096;
  border: 0.5px solid rgb(208, 208, 208);
  height: 60px;
  cursor: pointer;
}

.cal-day .calenderDay.active-days {
  background-color: rgb(237, 245, 236);
  color: #92e2be;
  border: 5px soild black;
}

.calander-Btn {
  font-size: 22px;
  color: rgb(84 141 119);
}

.month_year {
  display: flex;

  align-items: center;
}

.month_year h4 {
  font-size: 1.2rem;
  color: rgb(132, 199, 174);
}

.btn-calander {
  font-size: 1.7rem;
  cursor: pointer;
  color: rgb(132, 199, 174);
  margin: 2px 11px;
}

.day-Btn {
  margin-top: 7px;
  margin-left: 71px;
  font-weight: 700;
  color: rgb(67, 67, 67);
}

.day-Status {
  font-weight: 700;
  line-height: 1;
  font-size: 10px;
  color: #000000bf;
  height: 27px;
  text-align: left;
  margin-left: 9px;
}
.week-off {
  background-color: rgb(246, 246, 246);
}
.half-day {
  background-color: rgb(249, 238, 240);
}
.pending {
  background-color: rgb(254, 255, 217);
}
.full-day {
  background-color: rgb(232, 244, 237);
}
.absent {
  background-color: rgb(253, 228, 233);
}
.active-day {
  background-color: #fff59d;
}
.hours-text {
  font-size: 9px;
  margin-right: 60px;
  color: black;
  font-weight: 500;
}

.working-hour-div {
  height: 32px;
  display: flex;
  /* width: 74px; */
  flex-direction: column;
}

/* Light Gray for Week Off */
.week-off {
  background-color: #d3d3d354;
}

/* Light Green for Full Day */
.full-day {
  background-color: #e9f4ed;
}

/* Light Red for Absent */
.absent {
  background-color: #f7b596ab;
}

/* Less than 8.5 Hours - Light Pink */
.low-hours {
  background-color: #ffe3e3;
}

.month-display h4 {
  padding-top: 17px;
  color: rgb(132, 199, 174);
}

/* Tablets (width ≤ 1024px) */
/* Tablets (768px–1023px) */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .day-Status {
    line-height: 2;
    font-size: 10px;
    height: 27px;
    margin-left: 7px;
    text-align: left;
    color: black;
  }

  .month-display {
    margin-left: 10px;
  }

  .calender-weekday,
  .cal-day {
    font-size: 0.75rem;
    width: 100%;
  }

  .detail h3,
  .month_year h4 {
    font-size: 1rem;
  }

  .btn-calander {
    font-size: 1.2rem;
  }

  .day-Btn {
    margin-left: 53px;
    font-size: 0.9rem;
  }
  .calender-section {
    margin: 10px;
    width: 78%;
    border: 1px solid rgb(145, 145, 145);
    border-radius: 5px;
    overflow: scroll;
  }
}

/* Desktops (≥1024px) */
/* @media screen and (min-width: 1024px) {
  .header-section,
  .sub-section,
  .calender-data-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .calender-data-section {
    flex-direction: row;
  }

  #input-data,
  .select-section,
  .month-display,
  .calender-section,
  .data-section,
  .data-section__container {
    height: 340px;
  }

  .calender-weekday,
  .cal-day {
    font-size: 0.85rem;
  }

  .day-Btn {
    margin-left: 96px;
  }


} */

@media screen and (max-width: 767px) {
  .calender-data-section {
    display: flex;
    flex-direction: column;
  }
  .calender-section {
    width: 95%;
    overflow: auto; /* Changed to auto for better UX */
    border: 1px solid rgb(77, 216, 172); /* Light neutral border */
    border-radius: 16px; /* Smooth corners */
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1); /* Soft deep shadow */

    margin: 20px auto; /* Center with some spacing */
    transition: box-shadow 0.3s ease, transform 0.3s ease;
  }
  .calender-section {
    width: 95%;
    overflow: scroll;
  }
  .data-section__container {
    width: 95%;
    border: 2px solid rgb(77, 216, 172);
  }
  .calender-weekday,
  .cal-day {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    width: 100%;
    box-sizing: border-box;
  }
  .calender-weekday {
    gap: 70px;
    margin-left: 28px;
  }
  .calenderDay {
    padding: 1px;
    font-size: 0.9rem;
    color: #6b8096;
    border: 0.5px solid rgb(77, 216, 172);
    height: 60px;
    cursor: pointer;
  }
  .day-Status {
    line-height: 1;
    /* font-size: 8px; */
    color: rgb(53, 53, 53);
    font-weight: 600;
  }
  .detail {
    color: cadetblue;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .detail h3 {
    width: 100%;
  }
  .hours-text {
    width: 60px;
  }
  .day-Btn {
    margin-top: 0px;
    margin-left: 71px;
    font-weight: 500;
  }
  .working-hour-div {
    /* height: 32px; */
    width: 74px;
    /* flex-direction: column; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AttendanceDashboard/UserAttendance/UserAttendance.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;;;KAIK;;AAEL;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;;EAEb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;;EAEZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;qBACmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,sCAAsC;EACtC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;;EAEb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B,2BAA2B;AAC3B;EACE;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,UAAU;IACV,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG;;AAEH;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,cAAc,EAAE,kCAAkC;IAClD,mCAAmC,EAAE,yBAAyB;IAC9D,mBAAmB,EAAE,mBAAmB;IACxC,yCAAyC,EAAE,qBAAqB;;IAEhE,iBAAiB,EAAE,6BAA6B;IAChD,qDAAqD;EACvD;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;;IAEE,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,qCAAqC;IACrC,YAAY;IACZ,eAAe;EACjB;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,4BAA4B;EAC9B;AACF","sourcesContent":["* {\n  margin: 0;\n}\n\n.attendance-outer {\n  border: 0.5px solid rgb(162 162 162 / 17%);\n  /* border: red; */\n  border-radius: 13px;\n  width: auto;\n}\n\n.header-section {\n  width: 98%;\n  margin: 10px;\n  height: 50px;\n  display: flex;\n}\n.slect_Attendance_month {\n  margin-right: 10px;\n}\n#input-data {\n  width: 10%;\n  margin-left: 10px;\n  padding: 10px;\n}\n\n.calender-section {\n  margin: 10px;\n  width: 78%;\n  border: 1px solid rgb(145, 145, 145);\n  border-radius: 5px;\n}\n\n.calender-data-section {\n  display: flex;\n  margin-top: -12px;\n  justify-content: space-evenly;\n}\n/* .btn-section {\n    display: flex;\n    border: 2px solid black;\n    width: 20px;\n  } */\n\n.select-section {\n  margin-left: auto;\n  border: 1px solid rgb(165, 164, 164);\n  padding: 10px;\n\n  border-radius: 5px;\n}\n\n.month-display {\n  height: 50px;\n  width: 220px;\n  display: flex;\n  /* justify-content: center; */\n  cursor: pointer;\n}\n#Search {\n  background-color: rgb(132, 199, 174);\n  color: white;\n  padding: 10px;\n  width: 70px;\n  margin-left: 10px;\n  border-radius: 5px;\n}\n\n.export {\n  background-color: rgb(132, 199, 174);\n  color: white;\n  margin-left: 10px;\n  padding: 10px;\n  width: 70px;\n  border-radius: 5px;\n}\n\n.sub-section {\n  width: 100%;\n  margin: 0px;\n  height: 44px;\n\n  display: flex;\n}\n\n.data-section {\n  margin: 10px;\n  border: 1px solid rgb(153, 153, 153);\n  border-radius: 13px;\n  min-width: 270px;\n  max-width: 100%;\n}\n@media screen and (max-width: 1024px) {\n  .data-section {\n    width: 20%;\n  }\n}\n\n.detail {\n  color: cadetblue;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* min-width: 200px;\n  max-width: 220px; */\n}\n\n.detail h3 {\n  padding: 10px;\n  width: auto;\n  margin: 10px;\n  text-align: center;\n  border-bottom: 2px solid green;\n}\n.data-section__container {\n  margin: 10px;\n  width: 250px;\n  border: 1px solid rgb(145, 145, 145);\n  border-radius: 13px;\n}\n.data-section__container ul {\n  list-style: none;\n  margin: auto;\n  margin-left: 5px;\n}\n\n.data-section__container li {\n  margin: 15px;\n  margin-left: 12px;\n  color: rgb(58, 58, 58);\n  opacity: 70%;\n  font-size: 13px;\n}\n\n.data-section__container span {\n  float: right;\n  color: rgb(66, 66, 66);\n  font-size: 12px;\n  font-weight: 550;\n}\n.data-contenet {\n  background-color: white !important;\n  padding: 10px;\n}\n\n.calender-weekday {\n  font-weight: 600;\n}\n\n.calender-weekday,\n.cal-day {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-top: 10px;\n  text-align: center;\n  color: rgb(84 141 119);\n}\n\n.calenderDay {\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  font-size: 0.9rem;\n  color: #6b8096;\n  border: 0.5px solid rgb(208, 208, 208);\n  height: 60px;\n  cursor: pointer;\n}\n\n.cal-day .calenderDay.active-days {\n  background-color: rgb(237, 245, 236);\n  color: #92e2be;\n  border: 5px soild black;\n}\n\n.calander-Btn {\n  font-size: 22px;\n  color: rgb(84 141 119);\n}\n\n.month_year {\n  display: flex;\n\n  align-items: center;\n}\n\n.month_year h4 {\n  font-size: 1.2rem;\n  color: rgb(132, 199, 174);\n}\n\n.btn-calander {\n  font-size: 1.7rem;\n  cursor: pointer;\n  color: rgb(132, 199, 174);\n  margin: 2px 11px;\n}\n\n.day-Btn {\n  margin-top: 7px;\n  margin-left: 71px;\n  font-weight: 700;\n  color: rgb(67, 67, 67);\n}\n\n.day-Status {\n  font-weight: 700;\n  line-height: 1;\n  font-size: 10px;\n  color: #000000bf;\n  height: 27px;\n  text-align: left;\n  margin-left: 9px;\n}\n.week-off {\n  background-color: rgb(246, 246, 246);\n}\n.half-day {\n  background-color: rgb(249, 238, 240);\n}\n.pending {\n  background-color: rgb(254, 255, 217);\n}\n.full-day {\n  background-color: rgb(232, 244, 237);\n}\n.absent {\n  background-color: rgb(253, 228, 233);\n}\n.active-day {\n  background-color: #fff59d;\n}\n.hours-text {\n  font-size: 9px;\n  margin-right: 60px;\n  color: black;\n  font-weight: 500;\n}\n\n.working-hour-div {\n  height: 32px;\n  display: flex;\n  /* width: 74px; */\n  flex-direction: column;\n}\n\n/* Light Gray for Week Off */\n.week-off {\n  background-color: #d3d3d354;\n}\n\n/* Light Green for Full Day */\n.full-day {\n  background-color: #e9f4ed;\n}\n\n/* Light Red for Absent */\n.absent {\n  background-color: #f7b596ab;\n}\n\n/* Less than 8.5 Hours - Light Pink */\n.low-hours {\n  background-color: #ffe3e3;\n}\n\n.month-display h4 {\n  padding-top: 17px;\n  color: rgb(132, 199, 174);\n}\n\n/* Tablets (width ≤ 1024px) */\n/* Tablets (768px–1023px) */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .day-Status {\n    line-height: 2;\n    font-size: 10px;\n    height: 27px;\n    margin-left: 7px;\n    text-align: left;\n    color: black;\n  }\n\n  .month-display {\n    margin-left: 10px;\n  }\n\n  .calender-weekday,\n  .cal-day {\n    font-size: 0.75rem;\n    width: 100%;\n  }\n\n  .detail h3,\n  .month_year h4 {\n    font-size: 1rem;\n  }\n\n  .btn-calander {\n    font-size: 1.2rem;\n  }\n\n  .day-Btn {\n    margin-left: 53px;\n    font-size: 0.9rem;\n  }\n  .calender-section {\n    margin: 10px;\n    width: 78%;\n    border: 1px solid rgb(145, 145, 145);\n    border-radius: 5px;\n    overflow: scroll;\n  }\n}\n\n/* Desktops (≥1024px) */\n/* @media screen and (min-width: 1024px) {\n  .header-section,\n  .sub-section,\n  .calender-data-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .calender-data-section {\n    flex-direction: row;\n  }\n\n  #input-data,\n  .select-section,\n  .month-display,\n  .calender-section,\n  .data-section,\n  .data-section__container {\n    height: 340px;\n  }\n\n  .calender-weekday,\n  .cal-day {\n    font-size: 0.85rem;\n  }\n\n  .day-Btn {\n    margin-left: 96px;\n  }\n\n\n} */\n\n@media screen and (max-width: 767px) {\n  .calender-data-section {\n    display: flex;\n    flex-direction: column;\n  }\n  .calender-section {\n    width: 95%;\n    overflow: auto; /* Changed to auto for better UX */\n    border: 1px solid rgb(77, 216, 172); /* Light neutral border */\n    border-radius: 16px; /* Smooth corners */\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1); /* Soft deep shadow */\n\n    margin: 20px auto; /* Center with some spacing */\n    transition: box-shadow 0.3s ease, transform 0.3s ease;\n  }\n  .calender-section {\n    width: 95%;\n    overflow: scroll;\n  }\n  .data-section__container {\n    width: 95%;\n    border: 2px solid rgb(77, 216, 172);\n  }\n  .calender-weekday,\n  .cal-day {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    width: 100%;\n    box-sizing: border-box;\n  }\n  .calender-weekday {\n    gap: 70px;\n    margin-left: 28px;\n  }\n  .calenderDay {\n    padding: 1px;\n    font-size: 0.9rem;\n    color: #6b8096;\n    border: 0.5px solid rgb(77, 216, 172);\n    height: 60px;\n    cursor: pointer;\n  }\n  .day-Status {\n    line-height: 1;\n    /* font-size: 8px; */\n    color: rgb(53, 53, 53);\n    font-weight: 600;\n  }\n  .detail {\n    color: cadetblue;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .detail h3 {\n    width: 100%;\n  }\n  .hours-text {\n    width: 60px;\n  }\n  .day-Btn {\n    margin-top: 0px;\n    margin-left: 71px;\n    font-weight: 500;\n  }\n  .working-hour-div {\n    /* height: 32px; */\n    width: 74px;\n    /* flex-direction: column; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
